(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-article"] && !window.DesignMode) return;
  try {
    

document.querySelectorAll('.article-content-inner-container h2').forEach(h2 => {
    const textContent = h2.textContent.trim();
    const id = textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    h2.id = id;
});


////////////////
  
  
// Fetch the active color from the data attribute
const activeColor = document.getElementById('color-variable').getAttribute('data-color');

const tableContentContainer = document.querySelector('.article-content-table-content');
const h2Elements = document.querySelectorAll('.article-content-inner-container h2');

// Clear existing content in .article-content-table-content
tableContentContainer.innerHTML = '';

// Create a new <ul> element
const ul = document.createElement('ul');

// Loop through each <h2> and create corresponding <li> and <a> elements
h2Elements.forEach(h2 => {
    const textContent = h2.textContent.trim().toLowerCase(); // Transform text to lowercase
    const id = h2.id;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = textContent; // Set the lowercase text

    // Add custom data-color attribute with the fetched color value
    a.setAttribute('data-color', activeColor);

    li.appendChild(a);
    ul.appendChild(li);
});

// Append the <ul> to the table content container
tableContentContainer.appendChild(ul);

// Optional: Remove the color-variable element after use
document.getElementById('color-variable').remove();


////////////////


// Function to handle scroll and manage active state
function handleScroll() {
    const h2Elements = document.querySelectorAll('.article-content-inner-container h2');
    const links = document.querySelectorAll('.article-content-table-content a');

    let activeIndex = -1;

    // Loop through all h2 elements to determine which section is in view
    h2Elements.forEach((h2, index) => {
        const h2OffsetTop = h2.offsetTop - 120; // Adjust for 120px offset
        const nextH2OffsetTop = h2Elements[index + 1]?.offsetTop - 120 || Infinity;

        // Check if the scroll position is within the current h2 range
        if (window.scrollY >= h2OffsetTop && window.scrollY < nextH2OffsetTop) {
            activeIndex = index;
        }
    });

    // Update active class for links
    links.forEach((link, index) => {
        if (index === activeIndex) {
            link.classList.add('active');
            const color = link.getAttribute('data-color');
            link.style.color = color; // Apply the color from the data-color attribute
        } else {
            link.classList.remove('active');
            link.style.color = ''; // Reset the color
        }
    });
}

// Smooth scroll to the target on clicking a link
function handleLinkClick(event) {
    event.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
        const targetOffset = targetElement.offsetTop - 120; // Adjust for 120px offset

        window.scrollTo({
            top: targetOffset,
            behavior: 'smooth',
        });
    }
}

// Attach event listeners
window.addEventListener('scroll', handleScroll);
document.querySelectorAll('.article-content-table-content a').forEach(link => {
    link.addEventListener('click', handleLinkClick);
});

// Trigger the scroll handler on page load
handleScroll();



  

  } catch(e) { console.error(e); }
})();
})();
